import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** A line-drawn leaf with central vein and side veins. Sways gently
 *  around the stem like a real leaf in still air. Pure decoration — used
 *  in corner ornaments on the home hero so the warm-paper aesthetic gets
 *  an organic counterpoint to the geometric form fields. */
export function IcnLeaf(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const reduced = useReducedMotion();
  return (
    <Svg {...rest} iconName="leaf" data-on={active ? 'true' : 'false'}>
      <g
        style={{
          transformOrigin: '13.5px 14px',
        }}
      >
        {/* leaf body */}
        <path d="M13.5 14 C 9 13, 5 9, 4 3 C 9 4, 13 7, 13.5 14 Z" />
        {/* central vein */}
        <path d="M13.5 14 C 10 11, 7 7, 5 4" opacity="0.7" />
        {/* two side veins */}
        <path d="M9 11.2 C 8.4 9.6, 8 7.8, 8 6.2" opacity="0.45" />
        <path d="M11 12 C 11 9.4, 11 7.4, 11 5.5" opacity="0.45" />
        {/* stem */}
        <path d="M13.5 14l1 1.5" />
        {!reduced && active && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="-3 13.5 14; 3 13.5 14; -3 13.5 14"
            dur="4.2s"
            repeatCount="indefinite"
          />
        )}
      </g>
    </Svg>
  );
}
